module.exports = __webpack_public_path__ + "static/site/img/banner_image_1.0a7e8697.svg";